import axiosInstance from "./axiosInstance";
import { atgAxiosInstance } from "./axiosInstance";

export const AuthAPI = {
  login: async (credentials) => {
    return axiosInstance
      .post("/login", credentials)
      .then((response) => response.data);
  },
  adminLogin: async (credentials) => {
    return atgAxiosInstance
      .post("/auth/oauth-auth-code-login", credentials)
      .then((response) => response.data);
  },
  googleAuthCodeLogin: async (credentials) => {
    return axiosInstance
      .post("/oauth-auth-code-login", credentials)
      .then((response) => response.data);
  },
  logout: async () => {
    return axiosInstance.post("/logout").then((response) => response.data);
  },

  getCurrentUser: async (params = {}) => {
    const requestParams = {};
    if (params.brand_id) requestParams.brand_id = params.brand_id;
    if (params.onboarding_brand_id)
      requestParams.onboarding_brand_id = params.onboarding_brand_id;
    return axiosInstance
      .get("/me", { params: requestParams })
      .then((response) => response.data);
  },

  sendOTP: async ({ email, purpose }) => {
    return axiosInstance
      .post("/send-otp", { email, purpose })
      .then((response) => response.data);
  },

  sendLoginOTP: async ({ email }) => {
    return axiosInstance
      .post("/send-login-otp", { email })
      .then((response) => response.data);
  },

  verifyLoginOTP: async ({ email, otp }) => {
    return axiosInstance
      .post("/verify-login-otp", { email, otp })
      .then((response) => response.data);
  },

  resetPassword: async ({ email, otp, newPassword }) => {
    return axiosInstance
      .post("/reset-password", { email, otp, newPassword })
      .then((response) => response.data);
  },

  getBrands: async () => {
    return axiosInstance
      .get("/all-brands-list")
      .then((response) => response.data);
  },

  getOnboardingBrands: async () => {
    return axiosInstance
      .get("/all-onbaording-brands-list")
      .then((response) => response.data);
  },

  createOnboardingUser: async (data) => {
    const response = await axiosInstance.post("/onboarding/create-user", data);
    return response.data;
  },

  validateOnboardingField: async (fieldType, value) => {
    const response = await axiosInstance.post("/onboarding/validate-field", {
      field_type: fieldType,
      value: value,
    });
    return response.data;
  },

  startSignupVerification: async ({ brandName, brandWebsite, designation }) => {
    const response = await axiosInstance.post(
      "/onboarding/start-verification",
      {
        brandName,
        brandWebsite,
        designation,
      },
      { timeout: 15000 },
    );
    return response.data;
  },

  getOnboardingVerificationStatus: async () => {
    const response = await axiosInstance.get("/onboarding/verification-status");
    return response.data;
  },
};
